import React, { useEffect } from 'react'
import { DEFAULT_IMAGE_400 } from "../../middleware/types";

const ProductModal = (props) => {

    function imageZoomed() {
        const target = document.getElementById("imgZoom")
        if (target.classList.contains("zoomed")) {
            target.classList.remove('zoomed')
        } else {
            target.classList.add('zoomed')
        }
    }
    useEffect(() => {
        document.querySelector('#productImage').addEventListener('hidden.bs.modal', function (e) {
            const target = document.getElementById("imgZoom")
            target.classList.remove('zoomed')
        })


    }, [])

    function replaceImage(event) {
		event.target.src = DEFAULT_IMAGE_400;

	}


    return (
        <div>

            <div id="productImage" class="modal fade " data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <img id="blurImage"onError={replaceImage} src={props.domainName.concat(props.productImage)} data-bs-dismiss="modal" />
                <button type="button" data-bs-dismiss="modal" aria-label="Close" style={{ right: "0", position: "absolute", width: "60px", height: "60px" }} class=" mz-button mz-button-close"></button>
                <div class="modal-dialog" style={{marginTop: "1rem"}}>
                    <div class="modal-content" style={{ backgroundColor: "black", border: "none" }}>
                        <img id="imgZoom" onError={replaceImage} onClick={() => imageZoomed()} class="modal-body p-0 imagepointer" src={props.domainName.concat(props.productImage)} />
                    </div>
                </div>


            </div>
        </div>
    )
}

export default ProductModal